import { render, staticRenderFns } from "./ModalUserTag.vue?vue&type=template&id=c762663e&scoped=true"
import script from "./ModalUserTag.vue?vue&type=script&lang=js"
export * from "./ModalUserTag.vue?vue&type=script&lang=js"
import style0 from "./ModalUserTag.vue?vue&type=style&index=0&id=c762663e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c762663e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c762663e')) {
      api.createRecord('c762663e', component.options)
    } else {
      api.reload('c762663e', component.options)
    }
    module.hot.accept("./ModalUserTag.vue?vue&type=template&id=c762663e&scoped=true", function () {
      api.rerender('c762663e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/team/components/ModalUserTag.vue"
export default component.exports